<template>
  <div class="room">
      <blue-print :bridgeId="bridgeId"></blue-print>
  </div>
</template>
<script>
import BluePrint from '../../components/BluePrint'

export default {
  name: 'bridgeImg',
  components: { BluePrint },
  data() {
    return {
        bridgeId: 'ca6d55dc-e059-4d72-b494-e3140e31b2fe'
    }
  },
}
</script>